import { NUMBER } from "../../../constants/app-constants";
import { PICKUP_STATUS, PRICE_DISCOVERY } from "../../../constants/seller-diy-constants";
import { HOLDBACK_TYPE } from "../post-inspection-diy-loan-noc-holdback/constant";

export const STEP_NAMES = {
    AUCTION_OVER: "AUCTION_OVER",
    TOKEN: "TOKEN",
    DOC_UPLOAD: "DOC_UPLOAD",
    SCHEDULE_PICKUP: "SCHEDULE_PICKUP",
    PICKUP_IN_PROGRESS: "PICKUP_IN_PROGRESS",
    PICKUP_COMPLETE: "PICKUP_COMPLETE"
};

export const RTO_DOCUMENT_TYPES = {
    RTO_DOCUMENTS: "RTO_DOCUMENTS",
    VEHICLE_DOCUMENTS: "VEHICLE_DOCUMENTS"
};

export const REQUIRED_DOCUMENTS_LIST = {
    KYC_DOCUMENTS: "KYC_DOCUMENTS",
    LOAN_DOCUMENTS: "LOAN_DOCUMENTS"
};

export const REQUIRED_DOCUMENTS_CATEGORY = {
    KYC_DOCUMENTS: "KYC Documents",
    SECONDARY_ADDRESS_PROOF: "Secondary Address Proof",
    LOAN_DOCUMENTS: "Upload loan documents",
    RTO_DOCUMENTS: "RTO Documents",
    VEHICLE_DOCUMENTS: "Vehicle Documents"
};

export const HOLD_TYPES = {
    NOC: "NOC HOLD",
    CHALLAN: "Challan HOLD",
    RC: "Party Peshi HOLD",
    SERVICE: "Service History HOLD",
    TOKEN: "Token",
    DELIVERY: "Delivery Amount",
    DUPLICATE_RC: "Duplicate RC HOLD",
    DUPLICATE_KEY: "Duplicate Key HOLD"
};

export const CHALLAN_TYPES = {
    PAID: NUMBER.FIFTEEN
};

export const CHARGE_TYPES = {
    SERVICE: "Service Charges",
    INSURANCE: "Insurance Charges",
    TOWING: "Towing Charges"
};

export const DOC_TYPES = {
    BANK_NOC: "BANK_NOC",
    HYPOTHECATION_FORM_35: "HYPOTHECATION_FORM_35",
    CHALLAN_CLEARANCE_RECEIPT: "CHALLAN_CLEARANCE_RECEIPT",
    DUPLICATE_RC: "ORIGINAL_RC",
    DUPLICATE_KEY: "DUPLICATE_KEY"
};

export const PAI_STATES = {
    PAI_PRICE_NO_BIDS: "PAI_PRICE_NO_BIDS",
    PAI_PRICE_NOT_AVAILABLE: "PAI_PRICE_NOT_AVAILABLE",
    PAI_PRICE_RECEIVED: "PAI_PRICE_RECEIVED",
    PAI_DNP_PRICE: "PAI_DNP_PRICE"
};

export const DIRECT_OCB_EXPERIMENT_VALUES = {
    D0_OCB: "D0_OCB",
    HIDDEN_AUCTION: "HIDDEN_AUCTION",
    USUAL_AUCTION: "USUAL_AUCTION"
};

export const DIRECT_OCB_VARIANTS = [
    DIRECT_OCB_EXPERIMENT_VALUES.D0_OCB,
    DIRECT_OCB_EXPERIMENT_VALUES.HIDDEN_AUCTION
];

export const REQUIRED_DOCUMENTS = [
    DOC_TYPES.BANK_NOC,
    DOC_TYPES.HYPOTHECATION_FORM_35,
    DOC_TYPES.CHALLAN_CLEARANCE_RECEIPT
];

export const APPLICABLE_RTO_DOC_LIST = [
    RTO_DOCUMENT_TYPES.RTO_DOCUMENTS,
    RTO_DOCUMENT_TYPES.VEHICLE_DOCUMENTS
];

export const DOCTET_API_APPLICABLE_STATES = [
    PICKUP_STATUS.PICKUP_CANCELLED,
    PICKUP_STATUS.PICKUP_SCHEDULED,
    PICKUP_STATUS.DRIVER_ASSIGNED,
    PICKUP_STATUS.PICKUP_IN_PROGRESS
];

export const DIY_DOCUMENT_VERFIFICATION_STATES = {
    NOT_UPLOADED: null,
    PENDING: "PENDING",
    UPLOADING: "UPLOADING",
    VERIFIED: "VERIFIED",
    UPLOADED: "UPLOADED",
    VERIFICATION_FAILED: "VERIFICATION_FAILED",
    PARTIALLY_MATCHED: "PARTIALLY_MATCHED",
    PARTIALLY_MATCHED_CONFIRMED: "PARTIALLY_MATCHED_CONFIRMED",
    OCR_FAILED: "OCR_FAILED",
    NOT_MATCHED: "NOT_MATCHED",
    SIZE: "SIZE",
    UPLOAD_PENDING: "UPLOAD_PENDING",
    VERIFICATION_PENDING: "VERIFICATION_PENDING",
    REJECTED: "REJECTED",
    WRONG_FORMAT: "WRONG_FORMAT",
    APPROVED: "APPROVED",
    APPROVED_WITH_HOLD: "APPROVED_WITH_HOLD",
    REJECTED_WITH_HOLD: "REJECTED_WITH_HOLD",
    VERIFICATION_SUBMIT_PENDING: "VERIFICATION_SUBMIT_PENDING",
    PICKED: "READY_FOR_PICK",
    CUSTOMER_VERIFY_PENDING: "CUSTOMER_VERIFY_PENDING",
    VERIFIED_WITH_REJECTIONS: "VERIFIED_WITH_REJECTIONS",
    SYSTEM_FAILED: "SYSTEM_FAILED",
    BANK_FAILED: "BANK_FAILED",
    MISMATCH: "MISMATCH",
    MISMATCH_CONFIRMED: "MISMATCH_CONFIRMED"
};

export const DIY_DOC_TYPES = {
    AADHAR_CARD: "AADHAR_CARD",
    AADHAR_CARD_FRONT: "AADHAR_CARD_FRONT",
    AADHAR_CARD_BACK: "AADHAR_CARD_BACK",
    PAN_CARD: "PAN_CARD",
    THIRD_PARTY_AADHAR_CARD: "THIRD_PARTY_AADHAR_CARD",
    THIRD_PARTY_PAN_CARD: "THIRD_PARTY_PAN_CARD",
    THIRD_PARTY_CONSENT_LETTER: "CONSENT_LETTER"
};

export const DIY_DOCUMENT_VERFIFICATION_STATE_MESSAGES = {
    OCR_FAILED: "Could not read. please re-upload",
    NOT_MATCHED: "Verification Failed. check the document",
    SIZE: "Only files under 10 MB size supported",
    WRONG_FORMAT: "Only images and PDF are supported",
    DEFAULT: "Upload failed, please try again."
};

export const DIY_THIRD_PARTY_STATES = {
    MISMATCH: "MISMATCH",
    PARTIALLY_MATCHED: "PARTIALLY_MATCHED",
    NOT_MATCHED: "NOT_MATCHED"
};

export const SCREEN_TYPES = {
    SELF_NEGOTIATION: "SELF_NEGOTIATION",
    REPEAT_USER: "REPEAT_USER",
    DIRECT_OCB: "DIRECT_OCB",
    DEFAULT: "DEFAULT",
    GS_OCB: "GS_OCB"
};

export const DIY_INTENT = {
    TOKEN: "TOKEN",
    DEFAULT: "DEFAULT"
};
export const APPLICABLE_THIRD_PARTY_SCENARIONS = [
    DIY_DOCUMENT_VERFIFICATION_STATES.CUSTOMER_VERIFY_PENDING,
    DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED
];

export const CONSENT_TYPES = {
    COMPANY: "COMPANY",
    FAMILY: "FAMILY",
    WRONG_RC_NAME: "WRONG_RC_NAME"
};

export const CONSENT_OPTIONS = [
    {
        type: CONSENT_TYPES.COMPANY,
        title: "Company-owned car. I am authorised by the company to sell it",
        subTitle: "For company owned cars",
        consentFromRcTitle: "I will provide the signed and stamped consent letter before pick up"
    },
    {
        type: CONSENT_TYPES.FAMILY,
        title: "I am a friend/family member of the car owner",
        subTitle: "For  friend’s/family member’s car",
        consentFromRcTitle: "I will provide the signed consent letter before pick-up"
    },
    {
        type: CONSENT_TYPES.WRONG_RC_NAME,
        title: "Name on RC is wrong"
    }
];

export const THIRD_PARTY_ID_PROOFS = {
    PAN: {
        title: "Pan Card",
        subTitle: "pan",
        state: DIY_DOCUMENT_VERFIFICATION_STATES.NOT_UPLOADED,
        type: DIY_DOC_TYPES.THIRD_PARTY_PAN_CARD
    },
    AADHAAR: {
        title: "Aadhaar card",
        subTitle: "aadhaar",
        state: DIY_DOCUMENT_VERFIFICATION_STATES.NOT_UPLOADED,
        type: DIY_DOC_TYPES.THIRD_PARTY_AADHAR_CARD
    },
    CONSENT_LETTER: {
        title: "Consent Letter",
        subTitle: "consent",
        state: DIY_DOCUMENT_VERFIFICATION_STATES.NOT_UPLOADED,
        type: DIY_DOC_TYPES.THIRD_PARTY_CONSENT_LETTER
    }
};

export const THIRD_PARTY_CONSENT_MAPPING = {
    consentType: "THIRD_PARTY_PAYMENT"
};

export const AADHAR_LABELS = {
    F: "Aadhar Front",
    B: "Aadhar Back"
};

export const AADHAR_PAGE = {
    F: DIY_DOC_TYPES.AADHAR_CARD_FRONT,
    B: DIY_DOC_TYPES.AADHAR_CARD_BACK
};

export const DIY_DOCUMENT_VIEW_ONLY_STATES = [
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING,
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFIED,
    DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED
];

export const DOC_FAILED_STATUSES = [
    DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED,
    DIY_DOCUMENT_VERFIFICATION_STATES.NOT_MATCHED
];

export const AADHAR_EKYC_DOCS = [
    DIY_DOC_TYPES.AADHAR_CARD,
    DIY_DOC_TYPES.AADHAR_CARD_FRONT
];

export const TRANSACTION_STATUS = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    PENDING: "PENDING"
};
export const FILTERED_TRANSACTION_LIST = [
    TRANSACTION_STATUS.SUCCESS,
    TRANSACTION_STATUS.PENDING
];

export const AUCTION_TYPE = {
    GS_OCB: "GS_OCB",
    OCB: "OCB",
    PAI: "PAI"
};

export const GS_AUCTION = "GS_AUCTION";

export const VIDEO_SLUGS = {
    POST_INSPECTION_DIY: "post_inspection_diy",
    DIRECT_OCB: "directOCB_videos",
    SELF_NEGO: "selfNego_videos"
};

export const LEAD_SCORE_CATEGORTY = {
    LOW: "LOW",
    HIGH: "HIGH"
};

export const LEADMON_TRANSACTION_STATUS = {
    PENDING: "PENDING",
    BOUGHT: "LEAD_BOUGHT"
};
export const PRICE_DISCOVERY_AUCTION_RUNNING = [
    PRICE_DISCOVERY.START,
    PRICE_DISCOVERY.NEGOTIATE_PRICE_REQUESTED
];
export const OFFLINE_FLOW_STATES = {
    OFFLINE: "OFFLINE",
    CARS24: "CARS24",
    NOT_SELECTED: "NOT_SELECTED"
};

export const OFFLINE_FLOW_STATUS = {
    NOT_RAISED: "NOT_RAISED",
    PENDING: "PENDING",
    BOUGHT: "BOUGHT",
    EXPIRED: "EXPIRED"
};

export const HOLDBACK_TYPES_FAQS = [HOLDBACK_TYPE.LOAN_NOC, HOLDBACK_TYPE.PARTY_PESHI];

export const BREAKUP_HOLDBACKS = {
    FAQ_LOAN_NOC: "FaqLoanNoc",
    FAQ_PARTY_PESHI: "FaqPartyPeshi"
};

export const FAQ_CODE = {
    [HOLDBACK_TYPE.LOAN_NOC]: BREAKUP_HOLDBACKS.FAQ_LOAN_NOC,
    [HOLDBACK_TYPE.PARTY_PESHI]: BREAKUP_HOLDBACKS.FAQ_PARTY_PESHI
};
